/**
 * Не существует в любой части переданных путей
 * @param paths
 * @param searchPath
 */
export const notExistsAnywhere = (paths: string[], searchPath: string) =>
  paths.filter((urlPart) => searchPath.indexOf(urlPart) > -1).length === 0
